// 搜索结果点击下载下方弹出推荐应用
import React, { memo, useCallback } from 'react';
import { useAliveController } from 'react-activation';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { logPostInfo } from '../../actions/log';
import { CONTEXT } from '../../config';
import Button from '../Button/Button';
import ApkButton from '../Button/Button';
import styles from './SoftCardZtShow.module.less';

export default memo(({ soft, logInfo, ztInfo }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { dropScope } = useAliveController();

  const handleSoftCard = useCallback(() => {
    // 跳转页面前更改source为source_p，改source_p为source_pp
    dispatch(
      logPostInfo({
        source_p: logInfo.source,
        source_pp: logInfo.source_p,
      }),
    );
    if (ztInfo.ztId) {
      dropScope('special');
      const timer = setTimeout(() => {
        history.push(
          `${CONTEXT}/special?ztId=${ztInfo.ztId}&scrollToSoft=${
            soft.androidType !== '1' ? soft.softID : soft.packageName
          }`,
        );
        clearTimeout(timer);
      }, 50);
    }
  }, [dispatch]);

  return (
    <div
      className={styles.soft_card}
      onClick={e => {
        if (e) {
          e.stopPropagation();
        }
        handleSoftCard(soft);
      }}
    >
      <div className={styles.soft_card_img_box}>
        <img className={styles.soft_card_img} src={soft.logoFile} alt="" />
        {soft.androidType === '1' && <div className={styles.soft_card_logo} />}
      </div>
      <div
        className={styles.soft_card_title}
        dangerouslySetInnerHTML={{ __html: soft.softName }}
        title={soft.softName && soft.softName.length > 5 ? soft.softName : ''}
      />
      <div
        className={styles.soft_card_opt}
        onClick={e => {
          e.stopPropagation();
        }}
      >
        {soft.androidType === '1' ? (
          <ApkButton
            soft={soft}
            info={{
              className: styles.soft_button,
              className_busing: styles.soft_button_busing,
              className_open: styles.soft_button_open,
            }}
            // 联想词softcard 做特殊处理  所以source_p, source_pp 通过父组件传入
            logInfo={{ ...logInfo }}
          />
        ) : (
          <Button
            soft={soft}
            info={{
              className: styles.soft_button,
              className_busing: styles.soft_button_busing,
              className_open: styles.soft_button_open,
            }}
            // 联想词softcard 做特殊处理  所以source_p, source_pp 通过父组件传入
            logInfo={{ ...logInfo }}
          />
        )}
      </div>
    </div>
  );
});
